<template>
  <div>
    <v-toolbar class="my-md-auto" elevation="0"  >
      <v-toolbar-title  class="hidden-md-and-down toolbartitle_50" >
        <h1><v-icon large>mdi-file-cog-outline</v-icon>{{$t('profile.profilefilesutils')}}</h1>
      </v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-container fluid>
      <v-row class="ma-6">
        <h2>Etape 1 : Ajout de l'identifiant lynxter sur tous les noeuds des fichiers (Fichier fff ou fichier Zip avec plusieurs fichiers / dossiers)</h2>
        <p>Attention le module ne doit pas être utilisé en simultané avec une autre personne ! Module en Alpha veuillez verifier les fichiers</p>
      </v-row>
      <v-row class="ma-6 ">
        <AddIdLynxterForm ref="AddIdLynxterForm" :values="item1" :errors="violations" class="maxwidthform"/>
      </v-row>
      <v-row class="ma-6">
        <v-btn
            :loading="isLoading"
            class="ml-sm-2"
            color="primary"
            @click="addIdLynxter"
          >
            {{ $t('global.submit')}}
          </v-btn>
      </v-row>
        
      <v-row class="ma-6">
        <h2>Etape 2 : Modifier une valeur sur tous les noeuds correspondant à l'id des fichiers (Fichier fff ou fichier Zip avec plusieurs fichiers / dossiers ,pensez à désarchiver le fichier de l'étape 1)</h2>
        <p>Attention le module ne doit pas être utilisé en simultané avec une autre personne ! Module en Alpha veuillez verifier les fichiers</p>
      </v-row>
      <v-row class="ma-6">      
        <UpdateValueLynxterForm ref="UpdateValueLynxterForm" :values="item2" :errors="violations" class="maxwidthform" />
      </v-row>
      <v-row class="ma-6">
        <v-btn
            :loading="isLoading"
            class="ml-sm-2"
            color="primary"
            @click="updateValueLynxter"
          >
            {{ $t('global.submit')}}
          </v-btn>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions,mapState } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import AddIdLynxterForm from '../../components/profilefile/AddIdLynxterForm';
import UpdateValueLynxterForm from '../../components/profilefile/UpdateValueLynxterForm';
import Loading from '../../components/Loading';
import NotificationMixin from '../../mixins/NotificationMixin';

const servicePrefix = 'ProfileFile';

const { mapFields } = createHelpers({
  getterType: 'profilefile/getField',
  mutationType: 'profilefile/updateField'
});

export default {
  name: 'ProfilefileUtils',
  servicePrefix,
  mixins: [NotificationMixin],
  components: {
    Loading,
    AddIdLynxterForm,
    UpdateValueLynxterForm
  },
  data() {
    return {
      item1: {},
      item2: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations']),
    ...mapState('profilefile', {
      actioned: 'actioned',
      updatedata: 'updatedata',
      action: 'action',
      error: 'error',
      isLoading: 'isLoading',
    }),
  },
  methods: {
    ...mapActions('profilefile', ['create', 'reset']),
    ...mapActions({
      profilefilePushActionDownload: 'profilefile/actionDownload',
      profilefileGetData: 'profilefile/data'
    }),
    addIdLynxter() {

      //this.mediaobjectPushUpload({ 'id' : this.item['id'], 'entity' : this.item['@entity'] , 'file' : this.inputfile });

      const addIdLynxterForm = this.$refs.AddIdLynxterForm;
      addIdLynxterForm.$v.$touch();
      if (!addIdLynxterForm.$v.$invalid) {
        this.profilefilePushActionDownload({action: 'formataddidlynxter',name: 'formataddidlynxter',values: {'file' :addIdLynxterForm.$v.item.$model.file}});
      } else {
        console.log('error');
      }
    },
    updateValueLynxter() {
      const updateValueLynxterForm = this.$refs.UpdateValueLynxterForm;
      updateValueLynxterForm.$v.$touch();
      if (!updateValueLynxterForm.$v.$invalid) {
        this.profilefilePushActionDownload({action: 'formatupdatevaluelynxter',name: 'formatupdatevaluelynxter',values: {'file' :updateValueLynxterForm.$v.item.$model.file, 'idlynxter' : updateValueLynxterForm.$v.item.$model.idlynxter , 'value' : updateValueLynxterForm.$v.item.$model.value}});
      } else {
        console.log('error');
      }
    },
  },
  watch: {
    actioned(actioned) {
      if (!actioned) {
        return;
      }
      if (this.action == 'formataddidlynxter') {
        //this.updatedProfil(actioned);
      }
      if (this.action == 'formatupdatevaluelynxter') {
        //this.updatedProfil(actioned);
      }
    },
    error(message) {
      message && this.showError(message);
    }
  }
};
</script>
<style>
.maxwidthform {
  width: 100%;
}
</style>
